var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3594 27.3278V5.67155H22.6875V0.837891L5.67188 3.7716V27.3278H1.03125V29.3903H6.63223L22.6875 31.6048V7.73405H26.2969V29.3903H31.9688V27.3278H28.3594ZM20.625 29.2383L7.73438 27.4603V5.509L20.625 3.28679V29.2383Z",
    fill: "#222222",
    fillOpacity: 0.59
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.9531H18.5625V19.0781H16.5V14.9531Z",
    fill: "#3A3A3A",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomViewIcon);
export default __webpack_public_path__ + "static/media/room-view-icon.3b6d087e8028601d9e88f29d6449cd9c.svg";
export { ForwardRef as ReactComponent };